<template>
	<div class="mis-amigos">
		<h1>Mis amigos</h1>
		<span class="subtitle">Al momento de realizar la compra o canje de ticket's, podrás elegir a tus amigos para agilizar el proceso.</span>
		<div class="amigos" v-if="amigos.length">
			<div class="amigo" v-for="amigo in amigos" :key="amigo.PersonaId">
				<div class="amigo-main">
					<div class="eliminar-amigo" content="Eliminar amigo" v-tippy="{ placement : 'left'}" @click="popupEliminar(amigo.PersonaId)"><trash-2-icon></trash-2-icon></div>
					<div class="amigo-row">
						<div class="amigo-input-group">
							<span class="label-dato">Nombre</span>
							<span class="valor-dato">{{ amigo.PersonaNombreCompleto }}</span>
						</div>
					</div>
					<div class="amigo-row">
						<div class="amigo-input-group">
							<span class="label-dato">Documento tipo</span>
							<span class="valor-dato">{{ amigo.PersonaDocumentoTipoNombre }}</span>
						</div>
					</div>
					<div class="amigo-row">
						<div class="amigo-input-group">
							<span class="label-dato">Documento</span>
							<span class="valor-dato">{{ amigo.PersonaDocumento }}</span>
						</div>
					</div>
				</div>
				<div class="amigo-socio">
					<div class="amigo-socio-group amigo-socio-group-30">
						<div class="socio-group-label">Socio Nº</div>
						<div class="socio-group-valor" v-if="amigo.PersonaSocioNro > 0">{{ amigo.PersonaSocioNro }}</div>
						<div class="socio-group-valor" v-else>-</div>
					</div>
					<div class="amigo-socio-group amigo-socio-group-70">
						<div class="socio-group-label">Categoría</div>
						<div class="socio-group-valor" v-if="amigo.PersonaSocioNro > 0">{{ amigo.PersonaSocioCategoriaNombre }}</div>
						<div class="socio-group-valor" v-else>-</div>
					</div>
				</div>
				<div class="amigo-butaca">
					<div class="amigo-socio-group">
						<div class="socio-group-label">Butaca código</div>
						<div class="socio-group-valor" v-if="amigo.PersonaButacaNro.length">{{ amigo.PersonaButacaNro }}</div>
						<div class="socio-group-valor" v-else>-</div>
					</div>
				</div>
			</div>
		</div>
		<div class="no-amigos" v-else>
			No se encontraron amigos
		</div>
		<modal class="promptEliminarAmigo" name="promptEliminarAmigo">
			<h2>¿Eliminar amigo?</h2>
			<p>¿Estás seguro que deseas eliminar el amigo?</p>
			<div>
				<button @click="cerrarModal">Cancelar</button>
				<button @click="eliminarAmigo" class="aux">Eliminar amigo</button>
			</div>
		</modal>
	</div>
</template>

<script>
	import axios from 'axios'
	import { Trash2Icon } from 'vue-feather-icons'

	export default {
		data(){
			return{
				usuarioId: localStorage.getItem('usuario_id'),
				amigos: [],
				amigoPersonaId: null
			}
		},
		components: {
			Trash2Icon
		},
		async mounted(){
			this.$store.dispatch('cargando', true);
			await this.cargoAmigos();
			this.$store.dispatch('cargando', false);
		},
		methods: {
			async cargoAmigos(){
				// Traigo mis amigos
				try {
					let response = await axios.post('/WSAmigosListar', { UsuarioId: this.usuarioId }, { headers: {"Authorization" : `Bearer ${this.$store.state.token}`} });

					if(response.data.ErrorCod === 11 || response.data.ErrorCod === 10 || response.data.ErrorCod === 1){
						this.$store.dispatch('destroyToken').then(response => {this.$router.push({ name: 'login' })})
					} else {
						if(response.data.ErrorCod === 0){
							this.amigos = response.data.SDTAmigos;
						} else {
							// Redirigir a 404 (no se encontró espectáculo)
							this.$router.push({ name: 'error' });
						}
					}
				} catch (error) {
					this.$router.push({ name: 'error' });
				}
			},
			cerrarModal(){
				this.amigoPersonaId = null;
				this.$modal.hide('promptEliminarAmigo');
			},
			popupEliminar(idPersona){
				this.amigoPersonaId = idPersona;
				this.$modal.show('promptEliminarAmigo');
			},
			eliminarAmigo(){
				// Elimino aamigo
				axios.post('/WSAmigoEliminar', {
					UsuarioId: this.usuarioId,
					AmigoPersonaId: parseInt(this.amigoPersonaId)
				},
				{
					headers: {"Authorization" : `Bearer ${this.$store.state.token}`}
				})
				.then(response => {
					if(response.data.ErrorCod === 11 || response.data.ErrorCod === 10 || response.data.ErrorCod === 1){
						this.amigoPersonaId = null;
						this.$store.dispatch('destroyToken')
						.then(response => {this.$router.push({ name: 'login' })})
					} else {
						if(response.data.ErrorCod === 0){
							this.amigoPersonaId = null;
							this.$toast.success('Amigo eliminado correctamente', {
								position: "bottom-left",
								timeout: 7000,
								closeOnClick: true,
								pauseOnFocusLoss: false,
								pauseOnHover: true,
								draggable: false,
								draggablePercent: 0.6,
								showCloseButtonOnHover: true,
								hideProgressBar: true,
								closeButton: "button",
								icon: true,
								rtl: false
							});

							this.amigos = response.data.SDTAmigos;
						} else {
							if(response.data.ErrorCod === 20){
								this.amigoPersonaId = null;
								this.$toast.error(response.data.ErrorDsc, {
									position: "bottom-left",
									timeout: 7000,
									closeOnClick: true,
									pauseOnFocusLoss: false,
									pauseOnHover: true,
									draggable: false,
									draggablePercent: 0.6,
									showCloseButtonOnHover: true,
									hideProgressBar: false,
									closeButton: "button",
									icon: true,
									rtl: false
								});

								this.amigos = reponse.data.SDTAmigos;
							} else {
								// Redirigir a 404 (cualquier otro error)
								this.$router.push({ name: 'error' });
							}
						}
					}
				})

				this.$modal.hide('promptEliminarAmigo');
			}
		}
	}
</script>

<style lang="scss" scoped>
	.mis-amigos{
		width: 100%;
		@include flex(column, flex-start, flex-start);

		h1{
			margin: 0;
			color: var(--color-red);
			font-weight: initial;
			font-size: 48px;
			line-height: 46px;
			font-family: var(--font-family-kapra-bold);
			text-transform: uppercase;
		}

		span.subtitle{
			font-size: 18px;
			line-height: 22px;
			font-family: var(--font-family-fira);
			font-weight: bold;
			color: var(--color-dark);
		}

		.amigos{
			width: 100%;
			margin: 30px 0 20px 0;
			display: grid;
			grid-template-columns: repeat(3, 1fr);
			// grid-auto-rows: 1fr;
			grid-column-gap: 20px;
			grid-row-gap: 20px;

			.amigo{
				padding: 0px;
				background-color: var(--color-white);
				position: relative;
				box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.1);
				@include flex(column, space-between, flex-start);

				.amigo-main{
					width: 100%;
					position: relative;
					padding: 20px;
					@include flex(column, flex-start, flex-start);

					.amigo-row{
						width: 100%;
						@include flex(row, space-between, center);
						margin: 3px 0;

						.amigo-input-group{
							width: 100%;
							@include flex(column, center, flex-start);

							&.amigo-input-group-50{
								width: 50%;
							}

							.label-dato{
								font-size: 16px;
								font-weight: var(--font-weight-regular);
								color: var(--color-grey);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								line-height: 19px;
								font-family: var(--font-family-fira);
							}

							.valor-dato{
								font-size: 16px;
								line-height: 25px;
								width: 100%;
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								color: var(--color-dark);
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
								padding-top: 2px;
							}
						}

						.amigo-row-column{
							@include flex(column, center, center);
							width: 100%;
						}
					}
				}

				.amigo-socio{
					padding: 20px;
					background-color: var(--color-blue);
					width: 100%;
					@include flex(row, space-between, center);
				}

				.amigo-butaca{
					padding: 20px;
					background-color: var(--color-blue-dark);
					width: 100%;
					@include flex(row, space-between, center);
				}

				.amigo-socio, .amigo-butaca{
					.amigo-socio-group{
						width: 100%;
						@include flex(column, flex-start, flex-start);

						&.amigo-socio-group-30{
							width: 30%;
						}

						&.amigo-socio-group-70{
							width: 70%;
						}

						.socio-group-label{
							color: var(--color-blue-light);
							font-size: 11px;
							line-height: 1em;
							font-family: var(--font-family-poppins);
							font-weight: bold;
							text-transform: uppercase;
						}

						.socio-group-valor{
							font-size: 24px;
							line-height: 28px;
							color: var(--color-white);
							font-family: var(--font-family-kapra-bold);
							text-transform: uppercase;
							margin: 0;
							-webkit-letter-spacing: 0;
							-moz-letter-spacing: 0;
							-ms-letter-spacing: 0;
							letter-spacing: 0;
						}
					}
				}

				.eliminar-amigo{
					position: absolute;
					top: 0px;
					right: 0px;
					width: 36px;
					height: 36px;
					background-color: var(--color-red);
					@include flex(row, center, center);
					padding: 0;
					margin: 0;
					cursor: pointer;
					transition: all .2s;

					&:hover{
						opacity: 0.9;
					}

					svg{
						width: 16px;
						height: auto;
						color: var(--color-white);
					}
				}
			}
		}

		.no-amigos{
			width: 100%;
			margin: 20px 0;
			font-size: 16px;
			font-family: var(--font-family-fira);
			background-color: var(--color-white);
			@include flex(row, center, center);
			padding: 40px 20px;
		}
	}

	/* Responsive */
	@media screen and (max-width: 1120px) {
		.mis-amigos{
			h1{
				font-size: 38px;
				line-height: 38px;
			}
			span.subtitle{
				font-size: 16px;
				line-height: 20px;
			}
			.amigos{
				grid-template-columns: repeat(2, 1fr);
			}
		}
	}

	@media screen and (max-width: 740px) {
		.mis-amigos{
			h1{
				font-size: 32px;
				line-height: 32px;
			}
			span.subtitle{
				font-size: 13px;
				line-height: 15px;
			}
			.amigos{
				grid-template-columns: repeat(1, 1fr);
			}
		}
	}
</style>